export interface IBasicMenuItem {
    /**
     * 唯一标识
     */
    id: string;
    /**
     * 标题
     */
    title: string;
    /**
     * 类型
     */
    type: NAV_MENU_TYPE;
    /**
     * 是否激活
     */
    active?: boolean;
    /**
     * 用户自定义的图标
     */
    icon_url?: string;
    /**
     * Agent名称
     */
    business_name?: string;
}
export interface IMenuItem extends IBasicMenuItem {
    icon?: string;
    expand?: boolean;
    customStyle?: string;
    onClick?: (item: IMenuItem) => void;
    children?: IMenuItem[];
}

export enum NAV_MENU_TYPE {
    /**
     * 历史记录类型
     */
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_MIND = 'TECH_MIND',
    MATERIAL_MIND = 'MATERIAL_MIND',
    IDEA_EXPLORATION = 'IDEA_EXPLORATION',
    TECH_RESEARCH = 'TECH_RESEARCH',
    TECH_FMEA = 'TECH_FMEA',
    PATENT_DISCLOSURE = 'PATENT_DISCLOSURE',
    AI_GENERATE = 'AI_GENERATE',
    LS_DOCUMENT_QA = 'LS_DOCUMENT_QA',
    LS_CHAT = 'LS_CHAT',
    LS_SAAS_CHAT = 'LS_SAAS_CHAT',
    LS_MARKUSH_PATENT_DRAFT = 'LS_MARKUSH_PATENT_DRAFT',
    TRIZ_MIND = 'TRIZ_MIND',
    LS_SAR = 'LS_SAR',
    LS_LCA = 'LS_LCA',

    HOME = 'HOME',
    CUSTOM_AGENT = 'CUSTOM_AGENT',
    AI_STUDIO = 'AI_STUDIO',
    MONITOR = 'MONITOR',
    MONITOR_TOPIC = 'MONITOR_TOPIC',
    MONITOR_SUBSCRIPTION = 'MONITOR_LIST',
    WORK_PROJECT = 'WORK_PROJECT',
    HISTORY = 'HISTORY',
    INCOGNITO = 'INCOGNITO',
    TECH_RISK = 'TECH_RISK',
    TRIZ = 'TRIZ',

    /**
     * 新菜单类型
     */
    NEW_TASKS = 'NEW_TASKS',
    SEARCH_TASKS = 'SEARCH_TASKS',
    KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
    COMMUNITY = 'COMMUNITY',
    VAULT = 'VAULT',

    AGENT_LIST = 'AGENT_LIST',
    CUSTOMIZE_LIST = 'CUSTOMIZE_LIST'
}

export interface NavMenuItem {
    /**
     * 菜单类型，唯一标识
     */
    type: NAV_MENU_TYPE;
    /**
     * 菜单标题
     */
    title?: string;
    /**
     * 菜单链接，历史记录数据是后端返回的，其余是前端配置的
     */
    link?: string;
    /**
     * 菜单图标
     */
    icon?: string;
    /**
     * 菜单模块，多包下区分是不是同一个模块，是的话需要使用vue-router进行跳转
     */
    module?: NAV_MENU_TYPE;
    /**
     * 路由名称(用于vue-router)
     */
    router?: string;
    /**
     * 历史记录ID，用于删除历史记录
     */
    id?: string;
    /**
     * 子菜单
     */
    children?: NavMenuItem[];
    /**
     * 是否是当前选中状态
     */
    active?: boolean;
    /**
     * 点击菜单事件,TODO 需要改组件库可去除这个参数
     */
    onClick?: () => void;
}

export interface HistoryRowData {
    /**
     * 跳转参数链接
     */
    link: string,
    /**
     * 历史记录标题
     */
    message: string,
    /**
     * 历史记录类型
     */
    source: NAV_MENU_TYPE,
    /**
     * 历史记录ID
     */
    id: string,
    /**
     * 历史记录创建时间
     */
    created_at: string,
    /**
     * 是否是当前选中状态
     */
    active?: boolean,
    /**
     * 历史记录图标
     */
    icon_url?: string,
    /**
     * 历史记录业务名称
     */
    business_name?: string,
}

export interface NavHistoryResponse {
    limit: number,
    page: number,
    history_maps: {
        date: string,
        data: HistoryRowData[]
    }[]
}

export interface HistoryItem extends NavMenuItem {
    business_name?: string;
    icon_url?: string;
}

export interface HistoryGroup {
    date: string;
    data: HistoryItem[];
}
